<div class="container-fluid" style="margin-bottom: 20px; padding-bottom: 20px;">
  <div *ngIf="showLoader" class="text-center">
    <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x" primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
  </div>
  <div *ngIf="!showLoader">
    <p-table [totalRecords]="businessUnits?.length" #dt [value]="businessUnits" styleClass="p-datatable-striped  p-datatable-responsive-eca"
             [scrollable]="!isOnMobile &&    businessUnits?.length > 5" scrollHeight="500px" dataKey="id"
             [responsive]="true" [columns]="columns" [globalFilterFields]="['name','description']">
      <ng-template pTemplate="caption">
        <div class="row d-flex justify-content-between align-items-center">
          <div class=" col-xl-auto col-lg-auto col-md-6 col-sm-12">
            <div class="row  justify-content-lg-start justify-content-md-start justify-content-sm-between justify-content-between align-items-center">
              <div class="col-auto">
                <h5 class="eca-primary-text h5-relative-font-size">
                  <span *ngIf="businessUnits ">{{ businessUnits.length  }}</span>
                  Business Units
                </h5>
              </div>
              <div class="col-auto">
                <app-eca-ghost-btn (btnClicked)="addNewItemClick()" btnText="Add" [disable]='showLoader' btnIcon="plus-circle" btnType="success"></app-eca-ghost-btn>
              </div>
            </div>
          </div>
          <div class=" col-xl-auto col-lg-auto col-md-6 col-sm-12 ">
            <div class="row  justify-content-lg-start justify-content-md-end justify-content-sm-between justify-content-between align-items-center">
              <div class="col-xl-auto col-lg-auto col-md-8 col-sm-8 col-8">
                <span class="p-input-icon-left">
                  <i class="pi pi-search"></i>
                  <input pInputText type="text" class="form-control" id="ctrlSearchInput"
                         style="min-width: 150px"
                         placeholder="Search All"
                         (input)="dt.filterGlobal($event.target.value, 'contains')">
                </span>
              </div>
              <div class="col-auto">
                <app-eca-ghost-btn btnIcon="file-excel" btnText="Export" btnType="primary" (btnClicked)="exportToExcel()"></app-eca-ghost-btn>
                <app-eca-ghost-btn class="card-action-icon float-right" btnIcon="question-circle" btnType="warning" (btnClicked)="openBusinessUnitHelp()"></app-eca-ghost-btn>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 43%;" pSortableColumn="name">
            Business Unit Name
            <p-sortIcon field="name"></p-sortIcon>
          </th>
          <th style="width: 43%;" pSortableColumn="description">
            Business Unit Description
            <p-sortIcon field="description"></p-sortIcon>
          </th>

          <th style="width: 14%"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-businessUnit let-columns="columns" style="margin: 15px;">
        <tr>
          <td *ngFor="let col of columns">
            <span class="p-column-title">{{col.header}}: </span>
            <label *ngIf="col.type=== 'text'">
              <span>{{businessUnit[col.field]}}</span>
            </label>
            <label *ngIf="col.type === 'html'" [innerHTML]="businessUnit[col.field] | ellipsis:140">
            </label>
          </td>
          <td>
            <app-eca-row-menu (viewBtnClicked)="editItemClick(businessUnit)"
                              viewBtnText="Edit"
                              [rowMenuItems]="rowMenuItems"
                              [contextItem]="businessUnit">
            </app-eca-row-menu>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
